import { render, staticRenderFns } from "./PhieuDangNamVien.vue?vue&type=template&id=9d9ded4c&scoped=true"
import script from "./PhieuDangNamVien.vue?vue&type=script&lang=js"
export * from "./PhieuDangNamVien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9ded4c",
  null
  
)

export default component.exports